import Modern from './Modern/Modern';
import Cards from './Cards/Cards';
import Columns from './Columns/Columns';
import Spotlight from './Spotlight/Spotlight';
import Timeline from './Timeline/Timeline';
import Table from './Table/Table';
import Compact from './Compact/Compact';
import Triptych from './Triptych/Triptych';
import Focus from './Focus/Focus';

const templates = { Modern, Cards, Columns, Spotlight, Timeline, Table, Compact, Triptych, Focus };

export default templates;
